import React from 'react';
import { useTranslation } from 'react-i18next';
import { apiDocStyles } from '../styles/apiDocStyles';

const Breadcrumb = ({ category, endpoint, onNavigate }) => {
  const { t } = useTranslation();

  return (
    <nav style={apiDocStyles.breadcrumb}>
      <span
        style={apiDocStyles.breadcrumbLink}
        onClick={() => onNavigate(null, null)}
      >
        {t('apiDoc.title')}
      </span>
      <span style={apiDocStyles.breadcrumbSeparator}>/</span>
      {category && (
        <>
          <span
            style={endpoint ? apiDocStyles.breadcrumbLink : apiDocStyles.breadcrumbCurrent}
            onClick={() => endpoint && onNavigate(category.id, null)}
          >
            {category.name}
          </span>
          {endpoint && (
            <>
              <span style={apiDocStyles.breadcrumbSeparator}>/</span>
              <span style={apiDocStyles.breadcrumbCurrent}>{endpoint.name}</span>
            </>
          )}
        </>
      )}
    </nav>
  );
};

export default Breadcrumb;
